export const dateFormatStartFun = (startOfToday) => {
    if(startOfToday == undefined || startOfToday == null)
       return undefined
    const startDate=new Date(startOfToday?.$d)
    // Check if date is valid
    if(isNaN(startDate.getTime()))
       return undefined
    startDate.setHours(startDate.getHours() + 5);
    startDate.setMinutes(startDate.getMinutes() + 30);
    // const startDate = moment(startOfToday.$d).format();
    return startDate.toISOString()
}



export const dateFormatEndFun = (endOfToday) => {
    if(endOfToday == undefined || endOfToday == null)
       return undefined
    const endDate=new Date(endOfToday?.$d)
    // Check if date is valid
    if(isNaN(endDate.getTime()))
       return undefined
    return endDate.toISOString()
}